import {Component, Input} from '@angular/core';
import {ButtonPadraoComponent} from "../../../shared/components/button-padrao/button-padrao.component";
import {DatePipe} from "@angular/common";
import {TextoMidiaEnum} from '../../../shared/enum/texto-midia-enum';

@Component({
  selector: 'app-prototipo-template',
  standalone: true,
    imports: [
        ButtonPadraoComponent,
        DatePipe
    ],
  templateUrl: './prototipo-template.component.html',
  styleUrl: './prototipo-template.component.css'
})
export class PrototipoTemplateComponent {

  @Input() template: any;
  @Input() texto?: string;


  protected readonly TextoMidiaEnum = TextoMidiaEnum;
  protected readonly Date = Date;

  get textoComQuebras(): string {
    return this.texto?.replace(/\n/g, '<br>') ?? '';
  }
}
